import { render, staticRenderFns } from "./accountEditPasswd.vue?vue&type=template&id=52bfe018"
import script from "./accountEditPasswd.vue?vue&type=script&lang=js"
export * from "./accountEditPasswd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports